import React from 'react';
import { Button, Dialog, DialogContent, DialogActions, Typography } from '@mui/material';
import StandardDialogHeader from '../StandardComponents/StandardDialog/StandardDialogHeader';
import { DIALOG_PAPER_SX, DIALOG_CONTENT_SX, DIALOG_ACTIONS_SX } from './dialogStyles';

/** Shared Billing Admin confirm dialog (Bulk Repoint pattern). */
export default function ConfirmDialog({ open, title, children, onClose, onConfirm, confirmLabel }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth={false} PaperProps={{ sx: DIALOG_PAPER_SX }}>
      <StandardDialogHeader title={title} onClose={onClose} />
      <DialogContent sx={DIALOG_CONTENT_SX}>
        <Typography variant="body2" sx={{ color: '#374151' }}>{children}</Typography>
      </DialogContent>
      <DialogActions sx={DIALOG_ACTIONS_SX}>
        <Button onClick={onClose} className="global-text-button">Cancel</Button>
        <Button variant="contained" className="global-danger-button" onClick={onConfirm}>{confirmLabel}</Button>
      </DialogActions>
    </Dialog>
  );
}
